<!-- <p><strong>{{idleState}}</strong></p> -->

<!-- <p *ngIf="lastPing"><small>Last keepalive ping <strong>{{lastPing}}</strong></small></p> -->

<!-- <button (click)="reset()" *ngIf="timedOut">Restart</button> -->


<a id="mbfs-header-login-cta" id="auto_trigger_logout" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogout($event)" hidden></a> 
<mbfs-header></mbfs-header>
<router-outlet></router-outlet>
<mbfs-footer-nav></mbfs-footer-nav>
